import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { CorporateInformationModel, CorporateProfileCompleteness, InvestorProfileCompleteness, ProgramOfficeInformationModel } from 'src/app/core/domain';
import * as InvestorDashboardAction from 'src/app/core/state/investor-dashboard/investor.dashboard.action';
import * as ProgramOfficeDashboardAction from 'src/app/core/state/program-office-dashboard/program-office.dashboard.action';
import { providingFundRequestFault, providingFundRequestSuccess } from 'src/app/core/state/investor-dashboard';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { ToastAlertService } from 'src/app/shared/utils/toast.service';
import { Router } from '@angular/router';
import { createSlug, getMissingFieldsMap } from '../../utils/common-methods';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShareProfileModalComponent } from '../share-profile-modal/share-profile-modal.component';
import { getBrandDetails } from 'src/app/core/state/global';
import { IBrandDetails } from 'src/app/core/domain/brand.model';
import { getProgramOfficeInfo } from 'src/app/core/state/program-office-members-info';
import { getProgramOfficeProfileCompleteness } from 'src/app/core/state/program-office-dashboard/program-office.dashboard.selectors';

@Component({
  selector: 'app-program-office-profile-completeness',
  templateUrl: './program-office-profile-completeness.component.html',
  styleUrls: ['./program-office-profile-completeness.component.scss']
})
export class ProgramOfficeProfileCompletenessComponent implements OnInit, OnDestroy {

  @Input() isUnderApproval = false;
  @Input() showShareFeedback = true;
  @Input() showEditProfileBtn = true;

  brandDetails: Partial<IBrandDetails>;

  public profileCompleteness: CorporateProfileCompleteness;
  private destroyed$: Subject<void> = new Subject();
  missingFields: Array<any> = [];
  programOfficeInfo: ProgramOfficeInformationModel;
  programOfficePageUrl
  constructor(
    private readonly store: Store,
    private toastAlertService: ToastAlertService,
    private router: Router,
    public modal: NgbModal,
  ) {
  }

  ngOnInit(): void {
    this.getProfileCompleteness();

    this.store.pipe(select(getBrandDetails)).pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.brandDetails = res;
      }
    })

    this.store.pipe(select(getProgramOfficeInfo)).pipe(takeUntil(this.destroyed$), distinctUntilChanged()).subscribe(res => {
      if (res) {
        this.programOfficeInfo = res.data;
        this.programOfficePageUrl = `/program-office-members/profile/${this.programOfficeInfo.uuid}/${createSlug(this.programOfficeInfo.name)}`;
      }
    })


    this.store.pipe(select(providingFundRequestSuccess)).pipe(takeUntil(this.destroyed$), distinctUntilChanged()).subscribe(res => {
      if (res) {
        this.toastAlertService.showToast(res);
      }
    })

    this.store.pipe(select(providingFundRequestFault)).pipe(takeUntil(this.destroyed$), distinctUntilChanged()).subscribe(res => {
      if (res) {
        this.toastAlertService.showToast(res, 'error');
      }
    })

  }

  getProfileCompleteness() {
    this.store.dispatch(new ProgramOfficeDashboardAction.GetProfileCompleteness());
    this.store.pipe(select(getProgramOfficeProfileCompleteness)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe(res => {
      if (res) {
        this.profileCompleteness = res;
        this.isUnderApproval = this.profileCompleteness && this.profileCompleteness?.isApprovalRequested && !this.profileCompleteness?.canToggleStatus && !this.profileCompleteness?.isApproved;

        this.getMissingFields();
      }
    })
  }


  getMissingFields = () => {
    this.missingFields = getMissingFieldsMap(this.profileCompleteness, 'program-office-members')
  }


  onToggleChange($event) {
    this.store.dispatch(new InvestorDashboardAction.ProvidingFundRequest);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }


  handleShareButton() {
    this.modal.open(
      ShareProfileModalComponent, { centered: true, size: 'lg' }
    )
  }



  get isProfileCompleted ( ) {
    return this.profileCompleteness?.percentage >= 100 && this.profileCompleteness?.isApproved;
  }


  get editProfileVisible() {
    return this.profileCompleteness?.percentage < 100 &&  this.showEditProfileBtn && !this.isUnderApproval
  }
  get isLimitedAccess() {
    return this.profileCompleteness?.isRejected && this.brandDetails?.features?.limited_access && this.profileCompleteness?.approvalStatus === 'limited_access'
  }

}
